(function () {
    angular.module('tmx-app')
        .controller('loginCtrl', ['$translate', '$filter', '$scope', '$auth', 'RegistrationUserDataService',
            '$mdDialog', 'ServerExceptionService', '$state', 'CurrentUserService', 'ToastService', 'cacheStore', 'UsersService', 'EncryptionService', 'TMX_FINANCE_CONSTANTS', 'tmxUtility',


            function LoginCtrl($translate, $filter, $scope, $auth, RegistrationUserDataService, $mdDialog,
                ServerExceptionService, $state, CurrentUserService, ToastService, cacheStore, UsersService, EncryptionService, TMX_FINANCE_CONSTANTS, tmxUtility) {

                var loginCtrl = this;
                var exists;

                exists = tmxUtility.exists;

                loginCtrl.UserName = 'UserName';
                loginCtrl.Password = 'Password';
                loginCtrl.SignIn = 'SignIn';
                loginCtrl.mainScreenBackgroundUrl = APP_CONSTANTS.mainScreenBackgroundUrl;
                loginCtrl.languages = [
                    {LookupId: 'en', VisibleValue: 'English', HiddenValue:'en'},
                    {LookupId: 'ar', VisibleValue: 'Arabic', HiddenValue:'ar'}
                ];
                loginCtrl.culture = localStorage.getItem('culture');

                //Encyption Service
                loginCtrl.EncryptionService = EncryptionService;

                //Encryption Key and IV
                var encryptKey = TMX_FINANCE_CONSTANTS.ENCRYPTION_KEY.key;
                var encryptIV = TMX_FINANCE_CONSTANTS.ENCRYPTION_KEY.iv;


                //if(angular.isDefined(ServerExceptionService.Displaymsg)){
                //     
                //    if(ServerExceptionService.Displaymsg != "" && ServerExceptionService.Displaymsg.search("Logged Out") != -1){
                //        //$scope.logout_msg = ServerExceptionService.Displaymsg;
                //        ToastService.showCustomToast("error", ServerExceptionService.Displaymsg);
                //    }
                //};


                //if($scope.watch_count == null || $scope.watch_count == undefined){
                //    //$scope.watch_count = AcrossScreenValidations.setWatch_value(2);
                //}


                ///////////////////CHECK TO SEE IF FIELDS ARE NULL OR PREFILLED///////////////////
                //  if($scope.username != null && $scope.username != undefined)
                //  {
                //      $scope.username = $scope.username;
                //      $scope.password = $scope.password;
                //  }


                ////////////  WATCHING FOR CHANGES IN THE ERROR in  RESPONSE IN LOGIN ///////////////////////////////////////
                $scope.$watch(function () { return ServerExceptionService.Displaymsg }, function (newVal, oldVal) {
                    if ($scope.watch_count > 1) {
                        $scope.logout_msg = "";
                        return;
                    }
                    //if(newVal.$scope.dataLoading == oldVal.$scope.dataLoading){return;}

                    if (typeof newVal !== 'undefined' && $scope.watch_count == 1) {

                        $scope.logout_msg = "";
                        $scope.error = ServerExceptionService.Displaymsg;
                        $scope.dataLoading = false;
                        $scope.watch_count = $scope.watch_count + 1;


                        ServerExceptionService.Displaymsg = oldVal;//to differentiate old value from new value when user signs
                        // in multiple time using incorrect username and password and the server returns the same error


                        $scope.$on("$destroy", function () {
                            ServerExceptionService.Displaymsg = "";

                        });
                    }

                });
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.termUse = function () {

                    $mdDialog.show({
                        controller: function ($scope, $mdDialog) {
                            $scope.hide = function () {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                        },
                        templateUrl: 'app/public/login/termUse.html',
                        parent: angular.element(document.body),
                        scope: $scope.$new(),
                        clickOutsideToClose: true
                    })
                        .then();
                };
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.policy = function () {

                    $mdDialog.show({
                        controller: function ($scope, $mdDialog) {
                            $scope.hide = function () {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                        },
                        templateUrl: 'app/public/login/policy.html',
                        parent: angular.element(document.body),
                        scope: $scope.$new(),
                        clickOutsideToClose: true
                    })
                        .then();
                };

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.login = function () {
                    $scope.error = "";
                    $scope.dataLoading = true;
                    $scope.watch_count = 1;

                    var loginEncrypted = false;
                    var loginPassword = $scope.password;
                    var loginUserName = $scope.username;

                    if (exists(APP_CONSTANTS.isEncrypted) && eval(APP_CONSTANTS.isEncrypted)) {
                        loginPassword = loginCtrl.EncryptionService.encrypt($scope.password, encryptKey, encryptIV);
                        loginUserName = loginCtrl.EncryptionService.encrypt($scope.username, encryptKey, encryptIV);
                        loginEncrypted = true;
                    }

                    var authUser = {
                        username: loginUserName,
                        password: loginPassword,
                        isEncrypted: loginEncrypted
                    };
                    $auth.login(authUser)
                        .then(function (response) {

                            if (angular.isDefined(response.status) && response.status == "200") {

                                // //Uncomment this code if there is no login call on MF
                                // $scope.dataLoading = false;
                                // postLogin(response);
                                // return;
                                // //Uncomment
                                var loginParams = {
                                    tokenExpiryTime:response.data[".expires"]
                                }
                                UsersService.loginToMF(loginParams).then(function (mfLoginResponse) {
                                    if (angular.isDefined(mfLoginResponse.status) && mfLoginResponse.status.code == 200) {
                                        $scope.dataLoading = false;
                                        if (mfLoginResponse.data.Success == true) {
                                            postLogin(response);
                                        }
                                        else {
                                            var message;
                                            switch (mfLoginResponse.status.message) {
                                            case "11":
                                                message = $filter('translate')("AlreadyLoggedInConfirmation");
                                                confirmationDialog(message, function () { forceLogin(response); }, function () { });
                                                break;
                                            default:
                                                message = "Cannot login to server due to unexpected response";
                                                ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                                break;
                                            }
                                            return;
                                        }
                                    }
                                    else {
                                        ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                    }
                                });

                            }
                            else {
                                ToastService.showCustomToast("error", response.data.status.message);
                            }

                            //if(ENV.backend == 'http://tmxprovisioningapi.azurewebsites.net/api'){
                            //    //$window.open('http://tmxmf.azurewebsites.net/develop/#/home/dashboard', '_self')
                            //
                            //}
                            //else{
                            //    //$window.open('http://172.17.40.106:85/tmxmf/portal/#/home/dashboard', '_self')
                            //    $state.transitionTo('private.dashboard');
                            //}


                        });
                    function forceLogin(response) {
                        $scope.dataLoading = true;
                        var loginParams = { EndPreviousSession: true };
                        UsersService.loginToMF(loginParams).then(function (mfLoginResponse) {
                            if (angular.isDefined(mfLoginResponse.status) && mfLoginResponse.status.code == 200) {
                                if (mfLoginResponse.data.Success == true) {
                                    postLogin(response);
                                }
                            }
                            else {
                                ToastService.showCustomToast("error", mfLoginResponse.status.message);
                            }
                        });
                    }

                    function postLogin(response) {
                        if (response.data.isFirstLogin == "true") {
                            CurrentUserService.firstLoginSetup();
                        }


                        loginCtrl.CurrentUser = response.data;
                        loginCtrl.CurrentUser.FirstName = response.data.firstName;
                        loginCtrl.CurrentUser.LastName = response.data.lastName;
                        loginCtrl.CurrentUser.Name = loginCtrl.CurrentUser.FirstName + ' ' + loginCtrl.CurrentUser.LastName;
                        loginCtrl.CurrentUser.ImageUrl = response.data.imageUrl;

                        if (loginCtrl.CurrentUser.ImageUrl == undefined || loginCtrl.CurrentUser.ImageUrl == null
                            || loginCtrl.CurrentUser.ImageUrl == "") {
                            loginCtrl.CurrentUser.ImageUrl = "assets/images/profile.jpg";
                        }
                        if (!angular.equals(loginCtrl.CurrentUser, CurrentUserService.getUser())) {
                            CurrentUserService.setUser(loginCtrl.CurrentUser);
                            //before transitioning populating the response data into local storage
                            localStorage.setItem("user", JSON.stringify(response.data));
                        }
                        cacheStore.removeAll();
                        $state.transitionTo('private.dashboard').then(function () {
                            $scope.dataLoading = false;
                        }, function () {
                            $scope.dataLoading = false;
                        });

                        

                        firebase.setTmxUserProperties({
                            UserName: loginCtrl.CurrentUser.Name,
                            UserEmail: loginCtrl.CurrentUser.userName,
                            Culture: tmxUtility.getCurrentCulture()
                        });
                        firebase.logTmxEvent('login_successful');
                    }

                }; //$scope.login function end

                $scope.changeCulture = function (culture) {
                    if(culture != null) {
                        localStorage.setItem('culture', culture);
                        $translate.use(culture);
                    }
                }

                $scope.authenticate = function (provider) {
                    $scope.formDisabled = true;
                    $scope.error = "";
                    $auth.authenticate(provider)
                        .then(function (response) {
                            if (response.data != null && response.data.status != null && response.data.status.code != 200) {
                                $scope.error = response.data.status.message;
                                return;
                            }
                            $scope.formDisabled = false;
                            if (response.data.access_token == "unregistered") {
                                localStorage.removeItem("TMX_access_token");
                                RegistrationUserDataService.user = {
                                    FirstName: response.data.firstName,
                                    LastName: response.data.lastName,
                                    EmailAddress: response.data.email,
                                    ImageUrl: response.data.imageUrl,
                                    ExternalProvider: response.data.externalProvider,
                                    ExternalAccessToken: response.data.externalAccessToken,
                                    ExternalSocialId: response.data.externalSocialId,
                                    SocialData: {}
                                };
                                $state.transitionTo('public.register');
                                //  $location.path('/register');
                            }
                            else {
                                if (response.data.isFirstLogin == "true") {
                                    CurrentUserService.firstLoginSetup();
                                }
                                $state.transitionTo('private.dashboard');
                            }
                        })
                        .catch(function (response) {
                            $scope.formDisabled = false;
                            if (response.data != null && response.data.message != null)
                                $scope.error = response.data.message;
                            else
                                $scope.error = "Your " + provider + " account cannot be linked";
                        });
                };

                function confirmationDialog(message, successCb, errorCb) {
                    var confirm = $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('Confirm')
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('Yes')
                        .cancel('No');
                    $mdDialog.show(confirm).then(successCb, errorCb);
                }
            }]);
})();